export const messages = {
  en: {
    adminShopVip: {
      searchConditions: 'Search Conditions',
      shopVip: 'Shop VIP',
      vipId: 'VIP ID',
      vipName: 'VIP Name',
      vipTel: 'Phone',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      vipLevel: 'VIP Level',
      birthday: 'Birthday',
      startTime: 'Start Time',
      endTime: 'End Time',
      search: 'Search'
    }
  },
  zh: {
    adminShopVip: {
      searchConditions: '查询条件',
      shopVip: '店铺会员',
      vipId: '会员编号',
      vipName: '会员名称',
      vipTel: '电话',
      gender: '性别',
      male: '男',
      female: '女',
      vipLevel: '会员等级',
      birthday: '会员生日',
      startTime: '开始时间',
      endTime: '结束时间',
      search: '查询'
    }
  }
}